import React, { useEffect, useState } from 'react';

import { fetchPartnerData } from 'src/services/mononoth/fetchPartnerData';
import { TextBlock } from '../../molecules/TextBlock/TextBlock';
import * as styles from './PartnerLegals.styles';

interface PartnerLegalsProps {
  shortcode?: string;
}

export const PartnerLegals = ({ shortcode }: PartnerLegalsProps) => {
  const [returnAddress, setReturnAddress] = useState<string | undefined>(undefined);
  const [vatNumber, setVatNumber] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!shortcode) {
      return;
    }
    let cancelled = false;
    const load = async () => {
      try {
        const response = await fetchPartnerData({ shortcode });
        if (cancelled) {
          return;
        }
        const content = response && 'partner' in response ? response : null;
        setReturnAddress(content?.partner?.returns_address);
        setVatNumber(content?.partner?.vat_number);
      } catch (error) {
        console.warn('Error fetching partner data from Mononoth', error);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [shortcode]);

  const returnAddressText = returnAddress ?? '';
  const vatNumberText = vatNumber ?? '';

  return (
    <>
      <hr css={styles.divider} />
      <TextBlock
        footerLinkHref="https://info.notonthehighstreet.com/hc/en-us/articles/360007444693-Delivery-Information?_gl=1%2A36y4bz%2A_gcl_au%2AMjA2OTgzNTU0MC4xNzY1ODk4Njk3"
        footerLinkText="delivery policy"
        footerText="Please see notonthehighstreet.com's"
        heading="Delivery"
      />
      <hr css={styles.divider} />
      <TextBlock
        bodyText={returnAddressText ?? ''}
        footerLinkHref="https://info.notonthehighstreet.com/hc/en-us/articles/206411168-What-is-your-returns-policy-?_gl=1*36y4bz*_gcl_au*MjA2OTgzNTU0MC4xNzY1ODk4Njk3"
        footerLinkText="returns policy"
        footerText="Please see notonthehighstreet.com's"
        heading="Returns"
      />
      <hr css={styles.divider} />
      <TextBlock
        footerLinkHref="https://www.notonthehighstreet.com/about/shopper-terms"
        footerLinkText="terms & conditions"
        footerText="Please see notonthehighstreet.com's"
        heading="Terms & conditions"
      />
      {vatNumberText && (
        <>
          <hr css={styles.divider} />
          <section css={styles.vatNumberSection}>
            <p>Registered VAT No.: {vatNumberText}</p>
          </section>
        </>
      )}
    </>
  );
};
